export const GRADES_ITEMS = [
    { value: 'A', name: 'Good' },
    { value: 'B', name: 'Poor' },
    { value: 'C', name: 'Faulty' }
]